export default __webpack_public_path__ + "static/media/swi.d236b2be.svg";